/* 🤖 this file was generated by svg-to-ts */
export const matIconAdfScanner: {
  name: 'adf-scanner';
  data: string;
} = {
  name: 'adf-scanner',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 12h-1V4H6v8H5c-1.66 0-3 1.34-3 3v5h20v-5c0-1.66-1.34-3-3-3zM8 6h8v6H8V6zm12 12H4v-3c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v3z"/><circle cx="18" cy="16" r="1"/></svg>`
};
